import React, { useEffect, useMemo, useState } from "react";
import {
  flexRender,
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";
import { InputGroup, Form, Tab, Button, Modal } from "react-bootstrap";
import { useDataFetch } from "../../hooks/useDataFetch";
import { useDegrees } from "../../hooks/useDegrees";
import { toast } from "react-toastify";

const DegreeChange = () => {
  const [studentsChange, setStudentsChange] = useState([]);
  const [yearFilter, setYearFilter] = useState(
    new Date().getFullYear().toString()
  );
  const [degreeFilter, setDegreeFilter] = useState("");

  const { getData, invalidateQuery, postData } = useDataFetch();

  const { status, data, error, isFetching, refetch } = getData(
    ["students"],
    "/students",
    { enabled: true },
    { year: yearFilter, degree: degreeFilter }
  );

  const { degrees: datadegreeList } = useDegrees(yearFilter);

  const { mutate: changeDegree, isLoading: isPostLoading } = postData(
    "/student/promote-students",
    {},
    {},
    {
      onSuccess: (data) => {
        invalidateQuery("students");
        refetch();
        setStudentsChange();
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const columns = useMemo(
    () => [
      {
        header: "",
        id: "select",
        cell: ({ row }) => (
          <div className="custom-control custom-checkbox mb-3 checkbox-warning check-xl">
            <input
              type="checkbox"
              className="custom-control-input"
              id={`change-${row.original.id}`}
              checked={studentsChange?.includes(row.original.id) ?? false}
              onChange={() => {
                setStudentsChange((prev) =>
                  prev?.includes(row.original.id)
                    ? prev.filter((id) => id !== row.original.id)
                    : [...(prev || []), row.original.id]
                );
              }}
            />
            <label
              className="custom-control-label"
              htmlFor={`change-${row.original.id}`}
            ></label>
          </div>
        ),
      },
      {
        accessorKey: "identification",
        header: "Identificación",
      },
      {
        accessorFn: (row) => `${row.first_name} ${row.last_name}`,
        id: "full_name",
        header: "Nombre",
      },
      {
        accessorFn: (row) => `${row.level || "-"} ${row.degree || "-"}`,
        id: "grade",
        header: "Grado",
      },
      {
        accessorKey: "status",
        header: "Estado",
        cell: ({ getValue }) => (getValue() === 1 ? "Activo" : "Inactivo"),
      },
    ],
    [studentsChange]
  );

  const table = useReactTable({
    data: data?.data ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  useEffect(() => {
    refetch();
  }, [yearFilter, degreeFilter]);

  const save = () => {
    if (studentsChange.length > 0) {
      changeDegree({ students: studentsChange });
    } else {
      toast.error("Se debe seleccionar por lo menos un ");
    }
  };

  return (
    <Tab.Container defaultActiveKey="all">
      <div className="d-flex justify-content-start">
        <div className="d-flex">
          <select
            className="form-control mb-3"
            onChange={(e) => setYearFilter(e.target.value)}
            style={{ width: 100 }}
          >
            <option selected={yearFilter == 2025 ? true : false} value={2025}>
              2025
            </option>
            <option selected={yearFilter == 2026 ? true : false} value={2026}>
              2026
            </option>
            <option selected={yearFilter == 2027 ? true : false} value={2027}>
              2027
            </option>
            <option selected={yearFilter == 2028 ? true : false} value={2028}>
              2028
            </option>
            <option selected={yearFilter == 2029 ? true : false} value={2029}>
              2029
            </option>
            <option selected={yearFilter == 2030 ? true : false} value={2020}>
              2030
            </option>
          </select>
          <select
            className="form-control mb-3 ml-3"
            onChange={(e) => setDegreeFilter(e.target.value)}
            style={{ width: 200 }}
          >
            <option value="">Todos los grados</option>
            {datadegreeList?.map((e) => (
              <option key={e.id} value={e.degree}>
                {e.level} {e.degree}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table card-table display dataTablesCard dataTable no-footer">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <hr className="mb-4" />
      <button
        className="btn btn-primary btn-lg btn-block"
        type="button"
        onClick={save}
        disabled={isPostLoading}
      >
        Cambiar
      </button>
    </Tab.Container>
  );
};

export default DegreeChange;
